import React, { Component } from 'react';
import { InputGroup, Row, Col, Table, Image } from 'react-bootstrap';
import NumericTextboxComponent from 'react-numeric-textbox';

export default class TPZType1 extends Component {
    constructor() {
        super();

        this.state = {
            distance: 0,
            tpzradius: 2,
            tpzarea: 12.6,
            srz: 1.5,
            distreq: 0,
            perclost: 0
        }

        this.updateDistance = this.updateDistance.bind(this)
        this.calcEncroachmentPercentage = this.calcEncroachmentPercentage.bind(this)
        this.calcEncroachmentArea = this.calcEncroachmentArea.bind(this)
        this.getEncoachmentPercentage = this.getEncoachmentPercentage.bind(this)
        this.getEncoachmentArea = this.getEncoachmentArea.bind(this)
    }

    componentDidMount = () => {
        console.log(this.props)

        this.setState({
            tpzradius: this.props.tpzradius,
            tpzarea: this.props.tpzarea,
            srz: this.props.srz
        })
    }

    updateDistance = (e) => {
        var distance = Number(e)

        this.setState({
            distance: distance
        })
    }

    calcEncroachmentArea = () => {
        var r = this.props.tpzradius
        var h = r - this.state.distance
        var area = Math.pow(r, 2) * Math.acos((r - h) / r) - (r - h) * Math.sqrt(2 * r * h - Math.pow(h, 2))

        return area;
    }

    calcEncroachmentPercentage = () => {
        var perclost = this.calcEncroachmentArea() / this.props.tpzarea

        return perclost * 100;
    }


    getEncoachmentPercentage = () => {
        var color = "black"
        var perc = this.calcEncroachmentPercentage().toFixed(1)

        if (perc >= 10) {
            color = "red"
        } else {
            color = "orange"
        }

        if (this.state.distance > this.props.tpzradius) {
            return (
                <div style={{ color: "#71b832" }}>
                    Works outside NRZ
                </div>
            )
        } else {
            return (
                <div style={{ color: color }}>
                    {perc}
                </div>
            )
        }
    }

    getEncoachmentLevel = () => {
        var color = "black"
        var perc = this.calcEncroachmentPercentage().toFixed(1)
        var level = ""

        if (perc >= 20) {
            color = "red"
            level = "Major"
        } else if (perc >= 10) {
            color = "red"
            level = "Moderate"
        } else {
            color = "orange"
            level = "Minor"
        }

        if (this.state.distance > this.props.tpzradius) {
            return (
                <div style={{ color: "#71b832" }}>
                    Works outside NRZ
                </div>
            )
        } else {
            return (
                <div style={{ color: color }}>
                    {level}
                </div>
            )
        }
    }

    getEncoachmentArea = () => {
        var color = "black"
        var perc = this.calcEncroachmentPercentage().toFixed(1)

        if (perc >= 10) {
            color = "red"
        } else {
            color = "orange"
        }

        if (this.state.distance > this.props.tpzradius) {
            return (
                <div style={{ color: "#71b832" }}>
                    Works outside NRZ
                </div>
            )
        } else {
            return (
                <div style={{ color: color }}>
                    {this.calcEncroachmentArea().toFixed(1)}
                </div>
            )
        }
    }

    handleClick() {
        this.refs.input.select();
    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs={{ order: 12 }} sm={{ order: 12 }}>
                        <label>Distance (m) from trunk centre to edge of works.</label>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>A</InputGroup.Text>
                            </InputGroup.Prepend>
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateDistance}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">m</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>


                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>Distance (m) for minor encroachment (10%)</td>
                                    <td class="text-right">{(this.props.tpzradius / 1.454).toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ radius (m)</td>
                                    <td class="text-right">{this.props.tpzradius.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>SRZ radius (m)</td>
                                    <td class="text-right">{this.props.srz.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ area (m²)</td>
                                    <td class="text-right">{this.props.tpzarea.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>Encroachment area (m²)</td>
                                    <td class="text-right">{this.getEncoachmentArea()}</td>
                                </tr>
                                <tr>
                                    <td>Encroachment (%)</td>
                                    <td class="text-right">{this.getEncoachmentPercentage()}</td>
                                </tr>
                                <tr>
                                    <td>Encroachment Level</td>
                                    <td class="text-right">{this.getEncoachmentLevel()}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col xs={{ span: 12, order: 'first' }} sm={{ span: 12, order: 'first' }} md={{ span: 4, order: 12 }} lg={{ span: 4, order: 12 }}>
                        <Image src="https://storage.googleapis.com/as4970-2025/NRZ_encroachment_type_A_graphic.png" height="250" />
                        <p>
                            <small>
                                Encroachment Type A: Works intersecting along a straight edge.<sup>2</sup>
                            </small>
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={{ span: 2, order: 'last' }} lg={{ span: 2, order: 'last' }}></Col>
                </Row>
            </div>
        )
    }
}